import BaseService from "@/shared/base.service";
import { useAlertStore } from "@/stores/alert.store";

export class SubscriptionService {
  static async GetClientSubscription(
    page: number,
    size: number,
    subscription_id?: string
  ): Promise<any | null> {
    try {
      const params = {
        page,
        size,
        subscription_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<any>(`subscriptions`, queryParams);

      return response ?? null;
    } catch (error) {
      console.error("Error in GetClientSubscription:", error);
      useAlertStore().show("error", "Erro ao buscar assinatura!");
      return null;
    }
  }

  static async CreateSubscription(payload: object): Promise<any | null> {
    try {
      const response = await BaseService.put<any>("subscriptions", payload);

      if (response) {
        useAlertStore().show("success", "Assinatura vinculada com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in CreateSubscription:", error);
      return null;
    }
  }

  static async ChangePaymentMethod(payload: object): Promise<any | null> {
    try {
      const response = await BaseService.put<any>("payment_method", payload);

      if (response) {
        useAlertStore().show("success", "Assinatura alterada com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in changeSubscription:", error);
      return null;
    }
  }

  static async ChangePlan(payload: object): Promise<any | null> {
    try {
      const response = await BaseService.put<any>("update_plan", payload);

      if (response) {
        useAlertStore().show("success", "Plano alterado com sucesso! A cobrança será feita na próxima data de vencimento.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in changePlan:", error);
      return null;
    }
  }

  static async CancelSubscription(subscriptionId?: string): Promise<any | null> {
    try {

      const params = {
        subscription_id: subscriptionId,
      };

      const payload = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.delete<any>("subscriptions", payload);

      if (response) {
        useAlertStore().show("success", "Sua assinatura foi cancelada com sucesso!");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in cancelSubscription:", error);
      return null;
    }
  }
}
